import { render, staticRenderFns } from "./AddressSearch.vue?vue&type=template&id=668d9903&"
import script from "./AddressSearch.vue?vue&type=script&lang=js&"
export * from "./AddressSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports